import React from "react";
import { useHistory } from "react-router-dom";
import DashboardHeaderMenu from "../HeaderMenu";

import {
    DashboardHeaderContainer,
    DashboardHeaderSide,
    DashboardHeaderSideMobile,
    DashboardHeaderNav,
    DashboardHeaderAction,
    DashboardHeaderActionIcon,
    DashboardHeaderHomeIcon,
} from "./styled";

// Barra de navegação principal: sempre visível (também no celular), com botões
// grandes para dedinhos pequenos. O "voltar descomplicado" de qualquer tela.
export default function DashboardHeader({ page }){

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    const pages = [
        { title:'Atividades', emoji:'🎮', link:'dashboard/atividades', ref:'atividades' },
        { title:'Idiomas', emoji:'📚', link:'dashboard/learning', ref:'learning' },
        { title:'Bíblico', emoji:'💬', link:'dashboard/conversation', ref:'conversation' },
    ]

    return (
        <>
            <DashboardHeaderContainer>
                <DashboardHeaderSide>
                    <DashboardHeaderSideMobile>
                        <DashboardHeaderHomeIcon
                            src={`/icons/home.svg`}
                            alt="Início"
                            onClick={() => navigate('dashboard')}
                            title="Ir para o início"
                        />
                        <DashboardHeaderActionIcon
                            src={`/icons/logo_joinkids_idiomas_v_claro.png`}
                            alt="JoinKids Idiomas"
                            onClick={() => navigate('dashboard')}
                            style={{ cursor: 'pointer' }}
                        />
                    </DashboardHeaderSideMobile>
                </DashboardHeaderSide>
                <DashboardHeaderNav aria-label="Navegação principal">
                    {
                        pages.map((item, key) =>
                            <DashboardHeaderAction key={key} active={ page === item.ref } onClick={() => navigate(item.link) }>
                                <span aria-hidden="true">{ item.emoji }</span> { item.title }
                            </DashboardHeaderAction>
                        )
                    }
                </DashboardHeaderNav>
                <DashboardHeaderSide>
                    <DashboardHeaderMenu />
                </DashboardHeaderSide>
            </DashboardHeaderContainer>
        </>
    );
}
